






























































































import {Component, Vue} from 'vue-property-decorator';
import api from '@/infrastructure/api/api';
import download from '@/infrastructure/api/download';
import {progress} from '@/script/progress';
import ButtonPanel from '@/components/menu/panel/ButtonPanel.vue';
import IconButton from '@/components/atom/button/IconButton.vue';
import moment from 'moment';
import WholesaleSelector from '@/components/wholesale/WholesaleSelector.vue';
import ConfirmDialog from '@/components/atom/dialog/ConfirmDialog.vue';
import CompleteDialog from '@/components/atom/dialog/CompleteDialog.vue';
import AlertDialog from '@/components/atom/dialog/AlertDialog.vue';
import NormalButton from '@/components/atom/button/NormalButton.vue';
import {viewEditingStateModule} from '@/store/state/viewEditingState';
import {優先卸取込結果型, 優先卸型, 優先卸検索依頼型} from '@/type/wholesale/primary/wholesale';
import PrimaryWholesaleDetail from '@/views/wholesale/PrimaryWholesaleDetail.vue';
import FileUploadDialog from '@/components/atom/dialog/FileUploadDialog.vue';
import 優先卸検索条件チェッカー from '@/type/wholesale/primary/優先卸検索条件チェッカー';

@Component({
  components: {
    ButtonPanel,
    IconButton,
    ConfirmDialog,
    CompleteDialog,
    AlertDialog,
    NormalButton,
    WholesaleSelector,
    FileUploadDialog,
    Detail: PrimaryWholesaleDetail,
  },
})
export default class ListPrimaryWholesales extends Vue {
  // date
  検索依頼: 優先卸検索依頼型 | null = null;
  優先卸一覧: 優先卸型[] = [];
  選択優先卸: 優先卸型 | null = null;
  取込結果一覧: 優先卸取込結果型[] = [];
  アラートメッセージ: string | string[] | null = null;
  detailModal: boolean = false;

  // computed
  get 取込エラーが存在する(): boolean {
    return this.取込結果一覧.length > 0;
  }

  get 表示件数(): number {
    if (this.取込エラーが存在する) {
      return this.取込結果一覧.length;
    }
    return this.優先卸一覧.length;
  }

  // method
  検索条件入力エラー判定(name: string): boolean {
    if (!this.検索依頼) {
      return false;
    }
    const checker = new 優先卸検索条件チェッカー(this.検索依頼);
    return checker.hasError(name);
  }

  async initialize(): Promise<void> {
    viewEditingStateModule.初期化する();
  }

  async searchHandler(): Promise<void> {
    if (this.検索依頼 == null) {
      return;
    }
    const checker = new 優先卸検索条件チェッカー(this.検索依頼);
    if (checker.hasErrors()) {
      this.showAlert(checker.errorMessages());
      return;
    }
    await progress(this.search);
    this.選択優先卸 = null;
  }

  async search(): Promise<void> {
    if (this.検索依頼 == null) {
      return;
    }
    this.優先卸一覧 = [];
    this.取込結果一覧 = [];
    await api.優先卸を検索する(this.検索依頼)
      .then((response: any) => {
        this.優先卸一覧 = response.優先卸一覧;
        if (this.優先卸一覧.length === 0) {
          this.showAlert('該当の優先卸は存在しません');
        }
        if (response.アラートメッセージ) {
          this.showAlert(response.アラートメッセージ);
        }
      })
      .catch((error: any) => {
        this.showAlert(error.data.message);
      });
  }

  async Excelファイル出力前入力チェックをする(): Promise<void> {
    if (this.検索依頼 == null) {
      return;
    }
    const checker = new 優先卸検索条件チェッカー(this.検索依頼);
    if (checker.hasErrors()) {
      this.showAlert(checker.errorMessages());
      return;
    }
    this.openDialog('出力ダイアログ');
  }

  async exportHandler(): Promise<void> {
    await progress(this.export);
  }

  async export(): Promise<void> {
    if (!this.検索依頼) {
      return;
    }
    const now = new Date();
    await download.優先卸取込Excelを出力する('卸一括更新_' + moment(now).format('YYYYMMDDHHmmss') + '.xlsx', this.検索依頼);
    this.closeDialog('出力ダイアログ');
  }

  async 優先卸取込をする(アップロードファイル: File): Promise<void> {
    const params = new FormData();
    params.append('file', アップロードファイル);
    await api.優先卸取込Excelを取込する(params)
      .then((response: any) => {
        this.取込結果一覧 = response;
        if (this.取込エラーが存在する) {
          this.showAlert(['一部更新できませんでした。', 'エラー内容をご確認ください。']);
          return;
        }
        this.reload();
        this.openDialog('取込完了ダイアログ');
      })
      .catch((error: any) => {
        if (!error.data.errors) {
          this.showAlert(error.data.message);
        }
        if (error.data.errors) {
          this.showAlert(error.data.errors);
        }
      });
  }

  select(優先卸: 優先卸型): void {
    if (this.detailModal) {
      return;
    }
    this.選択優先卸 = 優先卸;
  }

  openDialog(name: string): void {
    this.$modal.show(name);
  }

  closeDialog(name: string): void {
    this.$modal.hide(name);
  }

  clear(): void {
    this.検索依頼 = {
      メーカー名: '',
      商品名カナ: '',
      卸コード: null,
    };
    this.優先卸一覧 = [];
    this.取込結果一覧 = [];
    this.closeDialog('クリアダイアログ');
    viewEditingStateModule.画面の編集を終了する();
  }

  openDetail(): void {
    this.detailModal = true;
    viewEditingStateModule.画面の編集を開始する();
  }

  closeDetail(): void {
    this.reload();
    this.detailModal = false;
    viewEditingStateModule.画面の編集を終了する();
  }

  reload(): void {
    this.search();
    this.選択優先卸 = null;
  }

  showAlert(message: string[] | string | null): void {
    this.アラートメッセージ = message;
    this.$modal.show('アラート');
  }

  // lifecycle hook
  created(): void {
    this.initialize();
    this.clear();
  }
}
